module.exports = __webpack_public_path__ + "static/media/settings.e9e8056f.svg";